import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/view/components/ui/dropdown-menu'
import { Calendar, Wallet, AArrowDown } from 'lucide-react'
import { ReactNode } from 'react'

type Props = {
  sort: string
  sortIcon: ReactNode
  onSortChange: (value: string) => void
}

export const LeadSortDropdown = ({ sort, sortIcon, onSortChange }: Props) => {
  return (
    <div className="ml-2 flex h-11 w-11 items-center rounded-lg border-b border-r border-t border-gray-200 bg-white02 px-3">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button type="button" className="text-primaryHex">
            {sortIcon}
          </button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="center" className="mr-24 mt-2">
          <DropdownMenuItem
            className={`py-3 ${sort === 'createdAt' ? 'text-primaryHex bg-gray-100' : ''}`}
            onSelect={() => onSortChange('createdAt')}
          >
            <Calendar size={20} className="mr-2" />
            Data
          </DropdownMenuItem>

          <DropdownMenuItem
            className={`py-3 ${sort === 'name' ? 'text-primaryHex bg-gray-100' : ''}`}
            onSelect={() => onSortChange('name')}
          >
            <AArrowDown size={20} className="mr-2" />
            Nome
          </DropdownMenuItem>

          <DropdownMenuItem
            className={`py-3 ${sort === 'availableBalance' ? 'text-primaryHex bg-gray-100' : ''}`}
            onSelect={() => onSortChange('availableBalance')}
          >
            <Wallet size={20} className="mr-2" />
            Saldo
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
